import ContainerModel from '../ContainerModel';
import PropertyDescriptor from '../../utils/PropertyDescriptor';

export default class PaperModel extends ContainerModel {

    layoutMode = new PropertyDescriptor('absolute', '布局方式', "布局", "enum", "#anticon-border-top", {
        values: [
            new PropertyDescriptor("absolute", "绝对定位", "布局方式", "string"),
            new PropertyDescriptor("flex", "线性布局", "布局方式", "string"),
        ],
        enabled: false
    });

    flex = new PropertyDescriptor(-1, "线性占比", "布局", "int", "#anticon-zoom-", {
        minValue: -1,
        maxValue: 100,
        enabled: false
    });

    minHeight = new PropertyDescriptor(0, "最小高度", "布局", "double", "#anticon-fit-height", { gallery: "外观", });

    x = new PropertyDescriptor(0, "X 坐标", "大小与位置", "double", "#anticon-icons-x_coordinate", { enabled: false });
    y = new PropertyDescriptor(0, "Y 坐标", "大小与位置", "double", "#anticon-icons-y_coordinate", { enabled: false });
    width = new PropertyDescriptor(100, "宽度", "布局", "double", "#anticon-fit-width", {
        gallery: "外观",
    });
    height = new PropertyDescriptor(100, "高度", "布局", "double", "#anticon-fit-height", {
        gallery: "外观",
    });

    scale = new PropertyDescriptor(1, "缩放比例", "大小与位置", "double", "#anticon-zoom-", { enabled: false });
    zIndex = new PropertyDescriptor(0, "层级", "大小与位置", "double", "#anticon-tab_manage", {
        description: "当多个部件重叠时，您可以使用该参数控制部件的重叠顺序，值越大越处于上层。",
        enabled: false,
    });
    margin = new PropertyDescriptor(0, '外边距', "大小与位置", "double", "#anticon-waibianju", { enabled: false });

    viewFitToWindow = new PropertyDescriptor(false, '拉伸页面', "视图", "bool", "#anticon-ZoomFit", {
        gallery: "外观",
        description: "该属性仅在预览时有效，开启后页面将拉伸至整个窗口范围"
    });

    viewBackgroundImage = new PropertyDescriptor('', '背景图片', "视图", "image", "#anticon-image", {
        gallery: "外观", placeholder: '请输入一个图片地址', description: "您需要输入一个网络地址，例如：http://yulintu.com/images/logo.png"
    });
    viewBackgroundColor = new PropertyDescriptor('#ececec', '背景颜色', "视图", "color", "#anticon-backgroundred", { gallery: "外观", });

    viewShadowEnabled = new PropertyDescriptor(true, '阴影', "视图", "bool", "#anticon-ShadowStyleMenu", { gallery: "外观", description: "启用后会在纸张周围出现阴影" });
    viewShadowSize = new PropertyDescriptor(40, "阴影大小", "视图", "double", "#anticon-Size", { gallery: "外观", });
    viewShadowColor = new PropertyDescriptor('#d8d8d8', '阴影颜色', "视图", "color", "#anticon-Scoringbackground", { gallery: "外观", });

    constructor(opts = {}) {
        super();

        this.padding.enabled = false;
        this.hidden.enabled = false;
        // this.messages.enabled = false;

        this.defineAllProperties();

        this.borderWidth = 1;
        this.borderColor = "#d3d3d3";
        this.backgroundColor = "#fff";
        this.isLock = true;

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {

        super.onPropertyValueChanged(name, valOld, valNew);
        if (subName === undefined && (name === "x" || name === "y")) {
            this[name] = 0;
        }
    }

    getType() {
        return "PaperModel";
    }

    getViewLocation() {
        return { x: 0, y: 0 };
    }

    getDataContext() {
        let data = this._sys.designer.props.data;
        data = data || this.dataContext.data;
        return data;
    }

    getParentDataContext() {
        let data = this._sys.designer.props.data;
        return data;
    }

    getInternalDataContext() {
        return null;
    }

    findById(id) {
        if (this.id === id)
            return this;

        let diagrams = this._sys.designer.diagrams;
        for (const d of diagrams) {
            const found = d.findById(id);
            if (found)
                return found;
        }

        return null;
    }

    toStyle() {

        let style = {
            ...super.toStyle(),
            boxShadow: `0 0 ${this.viewShadowEnabled ? this.viewShadowSize : 0}px ${this.viewShadowColor}`,
            minHeight: this.minHeight,
            ...super.getExtendStyle(),
        }

        style.pointerEvents = this._sys.designer && this._sys.designer.mode === "view" ? "auto" : "none";
        return style;
    }

    toViewStyle() {
        return {
            backgroundColor: `${this.viewBackgroundColor}`,
            backgroundImage: this.viewBackgroundImage && this.viewBackgroundImage.trim() ? "url(" + this.viewBackgroundImage.trim() + ")" : "",
            backgroundSize: '100% 100%',
        }
    }
}
